import { fromPromise } from 'xstate';
import { isDevelopment } from '../../helpers/env';
import { RefreshTokenSuccessEvent, AuthMachineContext } from '../types';
import { AuthTransport, resolveAuthHeaders } from '../transport';
import { request } from '../../helpers/request';

export type RefreshTokenInput = {
  // accessToken: AuthMachineContext['accessToken'];
  refreshToken: AuthMachineContext['refreshToken'];
  endpoint: {
    client: AuthMachineContext['endpoints']['refresh'];
    server: AuthMachineContext['endpoints']['ssrRefresh'];
  };
  /** Host-supplied header injection — see `../transport`. */
  transport?: AuthTransport;
};

export type RefreshTokenResponse = {
  access_token?: string;
};

export type RefreshTokenOutput = {
  type: string;
  accessToken: string;
};

const IS_SERVER = typeof window === 'undefined';

/** @todo pass locale for auth server? */
export const refreshAccessToken = fromPromise<
  RefreshTokenSuccessEvent,
  RefreshTokenInput
>(async ({ input }) => {
  if (!input.endpoint.client || input.endpoint.client === '') {
    if (isDevelopment) {
      console.log('refreshAccessToken: No client endpoint provided.');
    }
    throw new Error('No client endpoint provided.');
  }
  if (!input.endpoint.server || input.endpoint.server === '') {
    if (isDevelopment) {
      console.log('refreshAccessToken: No server endpoint provided.');
    }
    throw new Error('No server endpoint provided.');
  }
  // if (!input.accessToken) throw new Error('No access token provided.');

  let data: RefreshTokenResponse;

  if (IS_SERVER) {
    if (input.refreshToken === '') throw new Error('Unauthorized.');

    try {
      data = await request<RefreshTokenResponse>(input.endpoint.server, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          Cookie: `refresh_token=${input.refreshToken}`,
          'Content-Type': 'application/json',
          ...resolveAuthHeaders(input.transport, 'ssrRefresh'),
        },
      });

      if (typeof data.access_token === 'undefined') {
        throw new Error('Unauthorized.');
      }

      return {
        type: 'REFRESH_TOKEN_SUCCESS',
        accessToken: data.access_token,
      } as RefreshTokenSuccessEvent;
    } catch (err) {
      if (isDevelopment) {
        console.log(err);
      }
      throw new Error('Could not complete refresh request (server)');
    }
  } else {
    // client
    data = await request<RefreshTokenResponse>(input.endpoint.client, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...resolveAuthHeaders(input.transport, 'refresh'),
      },
      /** @todo is this necessary anymore? */
      body: JSON.stringify({
        grant_type: 'refresh_token',
        // client_id: 'default',
        // client_secret: 'Password123!',
        // scope: 'default',
      }).toString(),
    });

    if (typeof data.access_token === 'undefined') {
      throw new Error('Unauthorized.');
    }

    return {
      type: 'REFRESH_TOKEN_SUCCESS',
      accessToken: data.access_token,
    };
  }
});

export default refreshAccessToken;
